<script setup>
import { ref, defineExpose, inject, watch, nextTick } from "vue"
import customFieldCom from "./../common/customField.vue";
const detailInfo = inject('detailInfo')
const isCheckForm = ref(false)
const tabList = inject('tabList')
const current_tab = inject('current_tab')
//自定义字段list 底部
const customFieldsList = ref([
    // {
    //     name: '', // 文本名称
    //     fieldsList: [
    //         {
    //             name: '字段1', //字段名称
    //             unit: '', //字段单位
    //         },
    //         {
    //             name: '字段2', //字段名称
    //             unit: '', //字段单位
    //         },
    //         {
    //             name: '字段3', //字段名称
    //             unit: '', //字段单位
    //         },
    //     ],
    //     showUpload: false,
    //     showDelete: true,
    // },
    // {
    //     name: '', // 文本名称
    //     fieldsList: [
    //         {
    //             name: '字段1', //字段名称
    //             unit: '', //字段单位
    //         },
    //         {
    //             name: '字段2', //字段名称
    //             unit: '', //字段单位
    //         },
    //         {
    //             name: '字段3', //字段名称
    //             unit: '', //字段单位
    //         },
    //     ],
    //     showUpload: true,
    //     showDelete: true,
    //     id: 'otherInfoFiledUpload',
    //     accept: '', // 接受的类型
    //     fileList: [],
    //     fileMaxSize: 1024 * 1024 * 200, //200M
    // }
])
const filterImglist = (valList, imageInfo) => {
    // 根据存储的id 获取图片信息
    if (valList && valList.length && Object.keys(valList).length) {
        const fileList = valList.map(item => {
            return imageInfo[item]
        })
        return fileList
    }
    return []
}
const checkForm = () => {
    // 校验form数据是否完整
    isCheckForm.value = true
    let checkRes = true
    for (let k in customFieldsList.value) {
        const { fieldsList } = customFieldsList.value[k]
        for (let kk in fieldsList) {
            let { required, value } = fieldsList[kk]
            if (required && !value) {
                checkRes = false;
                break;
            }
        }
    }
    return checkRes
}

// 监听detailInfo 组装数据
watch(detailInfo, (val) => {
    //设置自定义字段list
    const { extra_info } = val
    if (extra_info && extra_info.children) {
        const etrList = extra_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
        // console.log(extra_info.children)
        if (etrList.length) {
            nextTick(() => {
                customFieldsList.value = etrList.map(item => {
                    let m = {
                        name: item.name, // 文本名称
                        name_en: item.name_en, // 文本名称
                        fieldsList: [],
                        showUpload: false,
                        showDelete: true,
                        key: item.key
                    }
                    if (item.children)
                        m.fieldsList = item.children.map(ele => {
                            return {
                                name: ele.name, //字段名称
                                name_en: ele.name_en, //字段名称
                                unit: ele.unit, //字段单位
                                key: ele.key,
                                value: ele.value,
                                required: ele.required,
                            }
                        })
                    if (item.extra.myKey == "文本项+附件项") {
                        m.showUpload = item.extra.showUpload
                        m.showDelete = item.extra.showDelete
                        m.id = item.extra.id
                        m.accept = item.extra.accept
                        m.fileList = filterImglist(item.value, val.imageInfo)
                        m.fileMaxSize = item.extra.fileMaxSize
                    }
                    return m
                })
            })
        } else {
            customFieldsList.value = [];
        }
    }
}, {immediate: true })

// 监听数据 如果数据长度为0  则不显示tab
watch(() => customFieldsList.value.length, (val) => {
    // console.log(val);
    if (val == 0) {
        tabList.value[tabList.value.length - 1].show = false;
        current_tab.value = 0
    }else{
        tabList.value[tabList.value.length - 1].show = true;
    }
},{immediate: true })

defineExpose({
    customFieldsList,
    checkForm
})
</script>
<template>
    <!-- 自定义字段及上传 -->
    <customFieldCom :isCheckForm="isCheckForm" v-model:customFieldsList="customFieldsList" />
</template>
<style scoped></style>